export default "__VITE_ASSET__DnInE38e__"